import { action } from 'typesafe-actions';
import {
  MovimentacoesTypes,
  IMovimentacoes,
  IFiltroMovi,
  Pagination,
  EtapaNota,
  IItensNota,
  IFilter,
  Sorter,
} from './types';

export const loadRequest = (
  filtro: IFiltroMovi | any,
  inscricaoAtiva: any,
  cddAtivo: number | undefined,
  pagination?: Pagination,
  sorter?: Sorter
) =>
  action(MovimentacoesTypes.LOAD_REQUEST, { filtro, inscricaoAtiva, cddAtivo, pagination, sorter });
export const loadSuccess = (data: IMovimentacoes[], pagination: Pagination) =>
  action(MovimentacoesTypes.LOAD_SUCCESS, { data, pagination });
export const loadFailure = () => action(MovimentacoesTypes.LOAD_FAILURE);

export const etapaNotaRequest = () => action(MovimentacoesTypes.ETAPA_REQUEST, {});
export const etapaNotaSuccess = (data: EtapaNota[]) =>
  action(MovimentacoesTypes.ETAPA_SUCCESS, {
    data,
  });
export const etapaNotaFailure = () => action(MovimentacoesTypes.ETAPA_FAILURE, {});

export const itensNotaRequest = (nuNota: number | undefined) =>
  action(MovimentacoesTypes.ITENS_NOTA_REQUEST_ENTRADA, { nuNota });

export const itensNotaSuccess = (itensNotaEntrada: IItensNota[]) =>
  action(MovimentacoesTypes.ITENS_NOTA_SUCCESS_ENTRADA, { itensNotaEntrada });
export const itensNotaFailure = () => action(MovimentacoesTypes.ITENS_NOTA_FAILURE_ENTRADA);

export const filterMovimentacoes = (filter: IFilter) =>
  action(MovimentacoesTypes.FILTER_Movimentacoes, { filter });

export const sorterMovimentacoes = (ordenacao: any) =>
  action(MovimentacoesTypes.SORTER_Movimentacoes, { ordenacao });

export const cleanDetalhesNota = () => action(MovimentacoesTypes.CLEAN_DETALHES_ITENS_NOTA);

export const cleanStateMoviEntrada = () => action(MovimentacoesTypes.CLEAN_MOVIENTRADA);
